import React, { PropsWithChildren, useContext, useEffect } from 'react';
import { RouterContext, RouterDispatchContext } from '../context/routing';
import { LoadingPage } from '../components/shared';
import { Role } from '../routing/utils';
import { useUser } from './User.store';

const Router: React.FC<PropsWithChildren> = ({ children }) => {
  const { init, routingMap } = useContext(RouterContext);
  const setRouter: $TSFixMe = useContext(RouterDispatchContext);
  const { data: user } = useUser();
  const userType: Role = user?.user_type === 'hauler' ? 'hauler' : 'citizen';

  useEffect(() => {
    setRouter({
      routingMap,
      roles: ['authenticated', userType],
      init: true,
    });
  }, [routingMap, setRouter, userType]);

  if (!init) return <LoadingPage />;

  return <>{children}</>;
};

export default Router;
